export default "__VITE_ASSET__CDzBHDlo__"